import React from 'react';
import MatchUpStandingsRow from './MatchUpStandingsRow';
import { useStandings } from '../../hooks/standings';
import { getClippedStandings } from '../../utils/standings';
import { filterStandings } from '../../utils/functionalUtils';

function MatchUpStandings({ match }) {
  const { configSeasonStartYear } = match;
  const [data] = useStandings(configSeasonStartYear);
  const standings = data ? filterStandings(data) : [];
  const { homeTeamId, visitingTeamId } = match;

  const renderItem = (item, markTeams) => {
    return (
      <MatchUpStandingsRow
        key={item.id}
        item={item}
        number={item.position}
        mark={
          markTeams.includes(item.teamShortName) ||
          markTeams.includes(item.teamId)
        }
      />
    );
  };

  const renderItems = () => {
    const markTeams = [];

    if (homeTeamId) {
      markTeams.push(homeTeamId);
    }
    if (visitingTeamId) {
      markTeams.push(visitingTeamId);
    }

    const standingsToRender = getClippedStandings(match, standings);

    return standingsToRender.map((item) => renderItem(item, markTeams));
  };

  return (
    <div className="row justify-content-center">
      <div className="col-12 tabs-column mt-5">
        <div className="stats-table">
          <div className="px-sm-3 stats-table__row stats-table__row--header">
            <div className="stats-table__name stats-table__name--header heading-h6 heading-sm-h3">
              Tabellen
            </div>
            <div className="stats-table__games heading-stats-name">S</div>
            <div className="stats-table__wins heading-stats-name">V</div>
            <div className="stats-table__ties heading-stats-name">O</div>
            <div className="stats-table__losses heading-stats-name">F</div>
            <div className="stats-table__plus-minus heading-stats-name">
              +/-
            </div>
            <div className="stats-table__points heading-stats-name">P</div>
          </div>
          {data && renderItems()}
        </div>
      </div>
    </div>
  );
}

export default MatchUpStandings;
